<template>
  <div class="designeroption" data-designer-component-id="smart_accessories" v-show="panel_required">
    <h3>{{ title }}</h3>
    <designer-question-nuki-fob
      :fabricator="fabricator"
      :fabricator_name="fabricator_name"
      v-model:target="localNukiKeyFob"
      :question="'nuki_keyfob'"
      :hardware-handle-internal="hardwareHandleInternal"
      :title="'Nuki Keyfob'"
      @update-option-count="updateKeyfobOptionCount"
    ></designer-question-nuki-fob>
    <designer-question-nuki-keypad
      :fabricator="fabricator"
      :fabricator_name="fabricator_name"
      v-model:target="localNukiKeyPad"
      :question="'nuki_keypad'"
      :hardware-handle-internal="hardwareHandleInternal"
      :title="'Nuki Keypad'"
      @update-option-count="updateKeypadOptionCount"
    ></designer-question-nuki-keypad>
  </div>
</template>

<script type="text/ecmascript-6">
    export default {
        emits: ['update:nuki-key-pad','update:nuki-key-fob'],
        data() {
          return {
            nuki_keyfob_option_count: 0,
            nuki_keypad_option_count: 0,
          };
        },
        props: {
            title: {
                default(){
                    return 'Smart Accessories';
                }
            },
            fabricator: {
              required: true
            },
            fabricator_name: {
              required: true
            },
            hardwareHandleInternal: {
                required: true
            },
            nukiKeyFob: {
              required: false,
              default() {
                return 67;
              }
            },
            nukiKeyPad: {
              required: false,
              default() {
                return 65;
              }
            },
        },
        methods: {
          updateKeyfobOptionCount(val) {
            this.nuki_keyfob_option_count = val;
          },
          updateKeypadOptionCount(val) {
            this.nuki_keypad_option_count = val;
          }
        },
        computed: {
            localNukiKeyFob: {
                get() {
                    return this.nukiKeyFob;
                },
                set(val) {
                    if(this.nukiKeyFob !== val) {
                        this.$emit('update:nuki-key-fob', val)
                    }
                }
            },
            localNukiKeyPad: {
                get() {
                    return this.nukiKeyPad;
                },
                set(val) {
                    if(this.nukiKeyPad !== val) {
                        this.$emit('update:nuki-key-pad', val)
                    }
                }
            },
          options_count() {
            return this.nuki_keyfob_option_count + this.nuki_keypad_option_count;
          },
          panel_required(){
            return this.options_count > 0;
          },
        },
    }
</script>
